import { render, staticRenderFns } from "./ProductScanner.vue?vue&type=template&id=afbbc396&scoped=true&"
import script from "./ProductScanner.vue?vue&type=script&lang=js&"
export * from "./ProductScanner.vue?vue&type=script&lang=js&"
import style0 from "./ProductScanner.vue?vue&type=style&index=0&id=afbbc396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbbc396",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VDivider,VImg})
